// Downscale a base64/data-URL image to a square N×N JPEG so we can safely
// send it to the backend as a profile picture. Returns a fresh data URL.
export async function resizeSquareDataUrl(src, size = 256, quality = 0.85) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = size;
        canvas.height = size;
        const ctx = canvas.getContext('2d');
        // paint a white background so PNGs with alpha don't turn into black boxes
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, size, size);
        // cover-fit the source image inside the square
        const scale = Math.max(size / img.width, size / img.height);
        const w = img.width * scale;
        const h = img.height * scale;
        ctx.drawImage(img, (size - w) / 2, (size - h) / 2, w, h);
        resolve(canvas.toDataURL('image/jpeg', quality));
      } catch (e) {
        reject(e);
      }
    };
    img.onerror = reject;
    img.src = src;
  });
}
